<template>
  <div class="login-widget">
    <div class="login-widget-wrapper">
      <!-- Premium login widget content -->
      <component is="script" ref="sphwavescript" :src="sphwavescriptURL()" async></component>
      <div ref="sphwavediv" class="cx_paywall_placeholder" :id="sphwavescriptID()"></div>
    </div>
    <iframe title="Web seamless login" v-if="isPremium && (user === null)" class="hidden-iframe" src="/p/login.php" />
  </div>
</template>

<script>
/**
 * TO TEST OAuth2
 *
 * => Production OAuth2
 * use your own account credential
 *
 * => mySPH UAT OAuth2
 * /// Test user accounts ///
 * stgraphics@test.com / st-graphics
 * stgraphics1@test.com / st-graphics
 * stgraphics2@test.com / st-graphics
 *
 */

import {mapState} from 'vuex'
export default {
  props: ['attributes'],
  computed: {
    ...mapState(['user', 'premium']),
    isPremium () {
      return process.env.IS_PREMIUM
    }
  },
  created () {
    window.loadSubscriberContent = () => {
      this.fetchUserDetail()
    }
  },
  mounted () {
    if (this.$refs.sphwavescript && this.$refs.sphwavediv) {
      this.run_SPH_CDP()
      this.addLoginLink()
    }
  },
  methods: {
    sphwavescriptURL () {
      if (this.isPremium && process.env.NODE_ENV === 'production') {
        return 'https://cdp.sph.com.sg/activation/activation.js' // Production
      }
      return 'https://uat-cdp.sph.com.sg/activation/activation.js' // UAT
    },
    sphwavescriptID () {
      if (this.isPremium && process.env.NODE_ENV === 'production') {
        return 'sph_cdp_4' // Production
      }
      return 'sph_cdp_226' // UAT
    },
    run_SPH_CDP () {
      var count = 0
      var intervalTimer = setInterval(() => {
        if (this.isPremium && process.env.NODE_ENV === 'production') {
          // Production
          SPH_CDP().init(
            '4',
            'https://cdp.activation.sph.com.sg',
            'c9875acb-576c-44bb-9484-aafb59ace74c').run()
        } else {
          // UAT
          SPH_CDP().init(
            '226',
            'https://uat-cdp.activation.sph.com.sg',
            'a0f81ff8-b337-48a5-8ac3-ae7b611bd954'
          ).run()
        }
        if (typeof SPH_CDP() === 'object' || ++count === 3) {
          window.clearInterval(intervalTimer)
        }
      }, 300)
    },
    addLoginLink () {
      var count = 0
      var _this = this
      var intervalUrlTimer = setInterval(() => {
        if (document.querySelector('.paywall-container')) {
          // Inject mySPH authorization URL to "Login" hyperlink
          document.querySelector('.paywall-container a.mysph_login').href = _this.$premium.getAuthorizationUrl()
          // If an authorized user is not logged in the ST app, remove the login link. Related with ST app seamless login flow.
          if (_this.$inSTApp || (_this.user !== null && _this.user.aologinid && !_this.user.expires)) {
            document.querySelector('.paywall-container #subscriber-query-container').remove()
          }
          if (document.querySelector('.paywall-container a.mysph_login').href !== 'javascript:;' || ++count === 3) {
            window.clearInterval(intervalUrlTimer)
          }
        }
      }, 300)
    },
    fetchUserDetail () {
      if (this.isPremium && this.user === null) {
        /* Call ST main login detail function and response JSON
         * Production: https://straitstimes.com/login_details.php
         * UAT: https://uat.straitstimes.com/login_details.php
         * User info will reply only same domains which mean if you test on https://uat.straitstimes.com/multimedia/graphics/* env, you can only get login detail from https://uat.straitstimes.com/login_details.php
         */
        window.fetch('/login_details.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(response => response.json())
          .then(data => {
            // Web seamless login flow
            if (data.seamless_login_from_app === 'no' && data.loginid && data.usertype !== 'anoy') {
              if (data.usertype === 'sub') {
                // If an authorized user is a subscriber, redirect to premium mySPH login page
                window.location.href = this.$premium.getAuthorizationUrl()
              } else {
                // If an authorized user is not a subscriber, set user info from ST main login_details.php
                this.$store.commit('pushResponse', {'user': {
                  aologinid: data.loginid,
                  aovisitorid: data.mysphw,
                  aonickname: data.display_name,
                  aoregservice: data.svc
                }})
                // If an authorized user is not a subscriber, remove the login link.
                if (document.querySelector('.paywall-container #subscriber-query-container') && !this.user.expires) {
                  document.querySelector('.paywall-container #subscriber-query-container').remove()
                }
              }
            }
          }).catch(err => {
            console.error(err)
          })
      }
      return null
    }
  }
}
</script>

<style lang="scss">
.login-widget {
  padding: 20px 0;

  &.inline {
    .login-widget-wrapper {
      max-width: $d_normal;
      // @include inline_align();
    }
  }

  iframe,
  .hidden-iframe {
    height: 0;
    visibility: hidden;
    display: none;
  }

  .login-widget-wrapper {
    max-width: 860px;
    margin: 0 auto;

    .premium-read-more a.subscribe-now {
      border-bottom: none;

      &:hover {
        border-bottom: none;
      }
    }
  }
}

.cx_paywall_placeholder {
  font-family: 'SelaneWebSTForty', $font-SelaneForty;
  font-family: 'Curator', $font-CuratorRegular;
}
</style>
